export interface GuidesSearchParams {
  page?: number;
  limit?: number;
  city?: string;
  state?: string;
  language?: string;
  specialization?: string;
  travelDate?: string;
  endDate?: string;
  minPrice?: number;
  maxPrice?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  travelers?: number;
}

export function parseGuidesSearchParams(search: string): GuidesSearchParams {
  const params = new URLSearchParams(search);
  const page = params.get('page');
  const minPrice = params.get('minPrice');
  const maxPrice = params.get('maxPrice');
  const travelers = params.get('travelers');

  return {
    page: page ? Number(page) : 1,
    limit: 12,
    city: params.get('city') || undefined,
    state: params.get('state') || undefined,
    language: params.get('language') || undefined,
    specialization: params.get('guideType') || params.get('specialization') || undefined,
    travelDate: params.get('date') || params.get('travelDate') || undefined,
    endDate: params.get('endDate') || undefined,
    minPrice: minPrice ? Number(minPrice) : undefined,
    maxPrice: maxPrice ? Number(maxPrice) : undefined,
    sortBy: params.get('sortBy') || undefined,
    sortOrder: (params.get('sortOrder') as 'asc' | 'desc') || undefined,
    travelers: travelers ? Number(travelers) : undefined,
  };
}

export function buildGuidesSearchParams(filters: GuidesSearchParams): URLSearchParams {
  const params = new URLSearchParams();
  if (filters.city) params.set('city', filters.city);
  if (filters.state) params.set('state', filters.state);
  if (filters.language) params.set('language', filters.language);
  if (filters.specialization) params.set('guideType', filters.specialization);
  if (filters.travelDate) params.set('date', filters.travelDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  if (filters.minPrice != null) params.set('minPrice', String(filters.minPrice));
  if (filters.maxPrice != null) params.set('maxPrice', String(filters.maxPrice));
  if (filters.sortBy) params.set('sortBy', filters.sortBy);
  if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
  if (filters.page && filters.page > 1) params.set('page', String(filters.page));
  if (filters.travelers) params.set('travelers', String(filters.travelers));
  return params;
}
